"use client";

import {
  CategoryScale,
  ChartData,
  Chart as ChartJS,
  Filler,
  LineElement,
  LinearScale,
  PointElement,
} from "chart.js";
import { DisabledCrosshair } from "charts/src/helpers/chart/plugins/config";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler);

const options = {
  type: "line",
  tension: 0.4,
  scales: {
    y: { display: false },
    x: { display: false },
  },
  responsive: true,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
    filler: { propagate: true },
    crosshair: DisabledCrosshair,
  },
};

type Props = {
  prices: {
    date: string;
    closePrice: number;
  }[];
};

export const LineChart = ({ prices }: Props) => {
  if (!prices) return null;

  const data: ChartData<"line", number[], string> = {
    labels: prices.map((price) => price.date),
    datasets: [
      {
        label: "Price",
        data: prices.map((price) => price.closePrice),
        borderColor: "#2862FF",
        borderWidth: 2,
        pointRadius: 0,
        fill: true,
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) return;

          const { top, bottom } = chartArea;
          const gradient = ctx.createLinearGradient(0, top, 0, bottom);
          gradient.addColorStop(0, "#DFE8FF");
          gradient.addColorStop(1, "#FFF");
          return gradient;
        },
      },
    ],
  };

  return <Line options={options} data={data} className="max-h-40 w-full" />;
};
